<template>
  <div class="appStatus">
    <v-alert
      v-if="appStatus === 'Temporary' || appStatus === 'Waiting'"
      border="left"
      icon="mdi-check"
      colored-border
      color="orange"
      elevation="2"
      style="font-size: 90%"
      class="mt-4"
    >
      <v-row>
        <v-col cols="12">
          <b>食事バッチリ！アプリチャレンジコース</b>
          <a class="ml-8" href="#" @click="toAppEntry()">概要と注意事項はこちら</a>
        </v-col>
        <v-col
          cols="12"
          md="8" offset-md="2"
        >
          <div class="orange rounded white--text" align="center" style="height:40px; line-height: 40px">
            <span v-if="appStatus === 'Temporary'">仮登録中</span>
            <span v-else-if="appStatus === 'Waiting'">キャンセル待ち</span>
          </div>
        </v-col>
        <v-col cols="12" class="pb-1">
          <span class="red--text">
            <span style="display: inline-block;">
              <b><span>アプリチャレンジコース参加手順が昨年から変更されています。必ず手順をご確認ください。<br/></span></b>
              <span class="pl-3">※アプリ上でサポーター追加をしないと、コース設定完了とはなりません。</span>
            </span>
            <span style="display: inline-block; vertical-align:top;">
              <v-btn @click="pdfForManual()" small color="error" class="ml-2">参加手順（PDF）</v-btn>
              <v-btn @click="pdfForForgotPassword()" small color="error" class="ml-2">パスワードを忘れた方</v-btn>
            </span>
          </span>
        </v-col>
        <v-col cols="12">
          <span>パスコードが、下記のスケジュールで登録メールアドレスに送付されるので、速やかに登録して下さい。<br/></span>
          <span class="red--text">登録完了期限以降はパスコードが無効になり登録できなく</span><span>なります。</span>
        </v-col>
        <v-col cols="12" v-if="appStatus === 'Waiting'">
          <span>※キャンセル待ちの方は、キャンセルが出た場合、申込日にかかわらず２または３のタイミングでメールをお送りします。</span>
        </v-col>
        <v-col
          cols="12"
          md="8" offset-md="2"
        >
          <table class="app_entry_table">
            <tr>
              <th></th>
              <th>申込日</th>
              <th>メール送付日</th>
              <th>登録完了期限</th>
            </tr>
            <tr>
              <td>１</td>
              <td>～9/20  15:00</td>
              <td>9/21</td>
              <td>10/11  15:00</td>
            </tr>
            <tr>
              <td>２</td>
              <td>～9/28  15:00</td>
              <td>9/29</td>
              <td>10/11  15:00</td>
            </tr>
            <tr>
              <td>３</td>
              <td>～10/6  15:00</td>
              <td>10/7</td>
              <td>10/11  15:00</td>
            </tr>
          </table>
        </v-col>
      </v-row>
    </v-alert>
    <v-alert
      v-else-if="appStatus === 'Completion'"
      border="left"
      icon="mdi-check"
      colored-border
      color="info"
      elevation="2"
      style="font-size: 90%"
      class="mt-4"
    >
      <v-row>
        <v-col cols="12">
          <b>食事バッチリ！アプリチャレンジコース</b>
          <a class="ml-8" href="#" @click="toAppEntry()">概要と注意事項はこちら</a>
        </v-col>
        <v-col
          cols="12"
          md="8" offset-md="2"
        >
          <div class="red rounded white--text" align="center" style="height:40px; line-height: 40px">
            <v-icon color="white">mdi-check-circle</v-icon> 登録完了
          </div>
        </v-col>
        <v-col cols="12">
          <span>こちらの画面ではなく、カロママプラスアプリに記録して下さい。<br/>
          ※達成賞の対象の方は、<span class="font-weight-bold">12月6日</span>に健康チャレンジキャンペーンサイトに反映されます。<br/><br/>
          </span>
        </v-col>
      </v-row>
    </v-alert>
    <v-alert
      v-else-if="appStatus === 'Canceled'"
      border="left"
      colored-border
      type="error"
      elevation="2"
      style="font-size: 90%"
      class="mt-4"
    >
      <b>食事バッチリ！アプリチャレンジコース（略：アプリチャレンジコース）がキャンセルになりました。</b><br/>
      期限内にパスコードを登録完了されなかったため、キャンセルになりました。<br/>
      アプリチャレンジコースには参加できませんので、再度コース設定をしてください。
    </v-alert>
    <v-alert
      v-else-if="appStatus === 'Expired'"
      border="left"
      colored-border
      type="error"
      elevation="2"
      style="font-size: 90%"
      class="mt-4"
    >
      <b>食事バッチリ！アプリチャレンジコース（略：アプリチャレンジコース）がキャンセルになりました。</b><br/>
      募集人数の上限に達したため、アプリチャレンジコースには参加できません。再度コースの設定をして下さい。
    </v-alert>
  </div>
</template>

<script>

export default {
  name: 'app_entry',
  props: ['appStatus'],
  data () {
    return {
      isLoading: false,
      hasError: false
    }
  },
  computed: {
    campaign () {
      return this.$store.getters.getCampaign
    }
  },
  methods: {
    toAppEntry () {
      this.$router.push('/app_entry', () => {})
    },
    pdfForManual () {
      window.open('/app_challenge/manual.pdf', '_blank')
    },
    pdfForForgotPassword () {
      window.open('/app_challenge/forgot_password.pdf', '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
.app_entry_table {
  table-layout: auto;
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem !important;
  th, td {
    padding: 5px 10px;
    border: 1px solid #ccc;
  }
  th {
    background-color: #FFF8E1;
  }
}
</style>
